export const BASE_URL = "https://cameet.site";
